<template>
  <div>
    <div class="row">
      <button type="button" @click="subsMonth()" class="btn btn-default"><i class="tim-icons icon-minimal-left"></i> Prev </button>
      <button type="button" @click="addMonth()" class="btn btn-default">Next <i class="tim-icons icon-minimal-right"></i></button>
      <button type="button" @click="addStartModel()" class="btn btn-default">Edit Start Month</button>
    </div>
    <div class="row">
      <div class="col-12">
        <card type="chart">
          <template slot="header">
            <div class="row">
              <div class="col-sm-6 text-left">
                <h5 class="card-category">Month Overview</h5>
              </div>
              <div class="col-sm-6">
                <div class="btn-group btn-group-toggle float-right"
                     data-toggle="buttons">
                  <label v-for="(option, index) in chartCategories"
                         :key="option"
                         class="btn btn-sm btn-primary btn-simple"
                         :class="{active: bigLineChart.activeIndex === index}"
                         :id="index">
                    <input type="radio"
                           @click="initBigChart(index)"
                           name="options" autocomplete="off"
                           :checked="bigLineChart.activeIndex === index">
                    {{option}}
                  </label>
                </div>
              </div>
            </div>
          </template>
          <div class="chart-area">
            <line-chart style="height: 100%"
                        ref="bigChart"
                        chart-id="big-line-chart"
                        :chart-data="bigLineChart.chartData"
                        :gradient-colors="bigLineChart.gradientColors"
                        :gradient-stops="bigLineChart.gradientStops"
                        :extra-options="bigLineChart.extraOptions">
            </line-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-6">
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-5">
          <div class="info-icon text-center icon-danger"><i class="tim-icons icon-spaceship"></i></div>
        </div>
        <div class="col-7">
          <div class="numbers">
            <p class="card-category">Increase in total savings</p>
            <h3 class="card-title">{{Math.round(((cal.endAmount-cal.startAmount)/cal.startAmount)*100)}}%</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="col-lg-3 col-md-6">
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-5">
          <div class="info-icon text-center icon-success"><i class="tim-icons icon-coins"></i></div>
        </div>
        <div class="col-7">
          <div class="numbers">
            <p class="card-category">Saved this month</p>
            <h3 class="card-title">{{curr}}{{cal.endAmount-cal.startAmount}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="col-lg-3 col-md-6">
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-5">
          <div class="info-icon text-center icon-info"><i class="tim-icons icon-user-run"></i></div>
        </div>
        <div class="col-7">
          <div class="numbers">
            <p class="card-category">Start Month</p>
          <h3 class="card-title">{{curr}}{{cal.startAmount}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="col-lg-3 col-md-6">
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-5">
          <div class="info-icon text-center icon-danger"><i class="tim-icons icon-wallet-43"></i></div>
        </div>
        <div class="col-7">
          <div class="numbers">
            <p class="card-category">End Month</p>
            <h3 class="card-title">{{curr}}{{cal.endAmount}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    </div>
    <div class="row">
      <div class="col-lg-4">
      <card type="chart">
        <template slot="header">
          <h2 class="card-category">Budget Overview</h2>
        </template>
        <div class="chart-area">
          <bar-chart style="height: 100%"
                     chart-id="blue-bar-chart"
                     :chart-data="overviewChart.chartData"
                     :gradient-stops="overviewChart.gradientStops"
                     :extra-options="overviewChart.extraOptions">
          </bar-chart>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card type="chart">
        <template slot="header">
          <h2 class="card-category">Expenses by category</h2>
        </template>
        <div class="chart-area">
          <bar-chart style="height: 100%"
                     chart-id="blue-bar-chart"
                     :chart-data="expansesChart.chartData"
                     :gradient-stops="expansesChart.gradientStops"
                     :extra-options="expansesChart.extraOptions">
          </bar-chart>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Income by category</h5>
        </template>
        <div class="chart-area">
          <bar-chart style="height: 100%"
                     chart-id="blue-bar-chart"
                     :chart-data="incomeChart.chartData"
                     :gradient-stops="incomeChart.gradientStops"
                     :extra-options="incomeChart.extraOptions">
          </bar-chart>
        </div>
      </card>
    </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">Planned Expanses</h5>
            <h3 class="card-title"><i class="tim-icons icon-chart-bar-32 text-success"></i> {{curr}}{{expensesTotal.planned}}</h3>
          </template>
          <div class="chart-area">
            <pie-chart style="height: 100%"
                        chart-id="green-line-chart"
                        :chart-data="plannedExpensesPieChart.chartData"
                        :gradient-stops="plannedExpensesPieChart.gradientStops"
                        :extra-options="plannedExpensesPieChart.extraOptions">
            </pie-chart>
          </div>
        </card>
      </div>
          <div class="col-lg-3">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">Actual Expanses</h5>
            <h3 class="card-title"><i class="tim-icons icon-chart-bar-32 text-success "></i> {{curr}}{{expensesTotal.actual}}</h3>
          </template>
          <div class="chart-area">
            <pie-chart style="height: 100%"
                        chart-id="green-line-chart"
                        :chart-data="actualExpensesPieChart.chartData"
                        :gradient-stops="actualExpensesPieChart.gradientStops"
                        :extra-options="actualExpensesPieChart.extraOptions">
            </pie-chart>
          </div>
        </card>
          </div>
            <div class="col-lg-3">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">Planned Income</h5>
            <h3 class="card-title"><i class="tim-icons icon-chart-bar-32 text-success"></i> {{curr}}{{incomeTotal.actual}}</h3>
          </template>
          <div class="chart-area">
            <pie-chart style="height: 100%"
                        chart-id="green-line-chart"
                        :chart-data="plannedincomePieChart.chartData"
                        :gradient-stops="plannedincomePieChart.gradientStops"
                        :extra-options="plannedincomePieChart.extraOptions">
            </pie-chart>
          </div>
        </card>
          </div>
            <div class="col-lg-3">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">Actual Income</h5>
            <h3 class="card-title"><i class="tim-icons icon-chart-bar-32 text-success "></i> {{curr}}{{incomeTotal.actual}}</h3>
          </template>
          <div class="chart-area">
            <pie-chart style="height: 100%"
                        chart-id="green-line-chart"
                        :chart-data="actualincomePieChart.chartData"
                        :gradient-stops="actualincomePieChart.gradientStops"
                        :extra-options="actualincomePieChart.extraOptions">
            </pie-chart>
          </div>
        </card>
    </div>

    </div>



    <div class="row">
  <div class="col-lg-6 col-md-12">
    <card type="tasks">
      <template slot="header">
        <h3 class="title d-inline">Expenses</h3>
        <base-dropdown menu-on-right=""
                       tag="div"
                       title-classes="btn btn-link btn-icon"
                       aria-label="Settings menu">
          <i slot="title" class="tim-icons icon-settings-gear-63"></i>
          <a class="dropdown-item" @click="addPlanModal('expenses')"><i slot="title" class="tim-icons icon-settings-gear-63"></i> Add Expenses Plan</a>
          <a class="dropdown-item" href="#pablo">Import</a>
        </base-dropdown>
      </template>
      <div class="table-full-width table-responsive">
        <table class="table tablesorter">
          <thead class="text-primary">
            <tr>
              <th>Category</th>
              <th>Planned</th>
              <th>Actual</th>
              <th>Difference</th>
              <th>Actions</th>
              </tr>
              <tr>
                <th>Total</th>
                <th>{{curr}}{{expensesTotal.planned}}</th>
                <th>{{curr}}{{expensesTotal.actual}}</th>
                <th>{{curr}}{{expensesTotal.diff}}</th>
                <th></th>
              </tr>
          </thead>
          <tbody class="">
            <tr v-for="expanse in expenses" :key="expanse._id">
              <td>
                {{expanse.category}}
              </td>
              <td>{{curr}}{{expanse.planned}}</td>
              <td>{{curr}}{{expanse.actual}}</td>
              <td>{{curr}}{{expanse.diff}}</td>
              <td><button type="button" @click="getPlan(expanse._id)" class="btn el-tooltip btn-link btn-icon btn-fab btn-neutral btn-sm" aria-describedby="el-tooltip-4624" tabindex="0">
                  <i class="tim-icons icon-pencil"></i>
                </button><button @click="deletePlan(expanse._id, 'expenses')" type="button" class="btn el-tooltip btn-link btn-icon btn-fab btn-neutral btn-sm" aria-describedby="el-tooltip-2585" tabindex="0">
                  <i class="tim-icons icon-simple-remove"></i>
                </button></td>
              </tr>
          </tbody>
        </table>
      </div>
    </card>
  </div>
  <div class="col-lg-6 col-md-12">
    <card type="tasks">
      <template slot="header">
        <h3 class="title d-inline">Income</h3>
        <base-dropdown menu-on-right=""
                       tag="div"
                       title-classes="btn btn-link btn-icon"
                       aria-label="Settings menu">
          <i slot="title" class="tim-icons icon-settings-gear-63"></i>
          <a class="dropdown-item" @click="addPlanModal('income')"><i slot="title" class="tim-icons icon-settings-gear-63"></i> Add Income Plan</a>
          <a class="dropdown-item" href="#pablo">Import</a>
        </base-dropdown>
      </template>
      <div class="table-full-width table-responsive">
        <table class="table tablesorter">
          <thead class="text-primary">
            <tr>
              <th>Category</th>
              <th>Planned</th>
              <th>Actual</th>
              <th>Difference</th>
              <th>Actions</th>
            </tr>
            <tr>
              <th>Total</th>
              <th>{{curr}}{{incomeTotal.planned}}</th>
              <th>{{curr}}{{incomeTotal.actual}}</th>
              <th>{{curr}}{{incomeTotal.diff}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody class="">
            <tr v-for="incom in income" :key="incom._id">
              <td>
                {{incom.category}}
              </td>
              <td>{{curr}}{{incom.planned}}</td>
              <td>{{curr}}{{incom.actual}}</td>
              <td>{{curr}}{{incom.diff}}</td>
              <td><button type="button" @click="getPlan(incom._id,)"  class="btn el-tooltip btn-link btn-icon btn-fab btn-neutral btn-sm">
                  <i class="tim-icons icon-pencil"></i>
                </button><button @click="deletePlan(incom._id, 'income')" type="button" class="btn el-tooltip btn-link btn-icon btn-fab btn-neutral btn-sm">
                  <i class="tim-icons icon-simple-remove"></i>
                </button></td>
    </tr>
          </tbody>
        </table>
      </div>
    </card>
  </div>
    </div>
    <modal
      :show.sync="modals.startModel"
      headerClasses="justify-content-center"
      class="modal-primary"
    >
      <h4 slot="header" class="title title-up">Start Month</h4>
        <div class="row"><label class="col-md-3 col-form-label">Amount</label>
          <div class="col-md-9">
            <div class="form-group">
              <div class="mb-0">
                <input aria-describedby="addon-right addon-left" v-model="startAmount" placeholder="Amount" class="form-control">
              </div>
            </div>
          </div>
        </div>
      <template slot="footer">
        <base-button @click.native="editStartAmount()">Edit</base-button>
        <base-button
          type="danger"
          @click.native="modals.startModel = false"
          >Close
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.planModal"
      headerClasses="justify-content-center"
      class="modal-primary"
    >
      <h4 slot="header" class="title title-up">Plan</h4>
        <div class="row"><label class="col-md-3 col-form-label">Category</label>
          <div class="col-md-9">
            <div class="form-group">
              <div class="mb-0">
                <input aria-describedby="addon-right addon-left" v-model="plan.category" placeholder="Category Name" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="row"><label class="col-md-3 col-form-label">Amount</label>
          <div class="col-md-9">
            <div class="form-group">
              <div class="mb-0">
                <input aria-describedby="addon-right addon-left" v-model="plan.plannedCost" placeholder="Planned Amount" type="email" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="row"><label class="col-md-3 col-form-label">Type</label>
          <div class="col-md-9">
            <div class="form-group">
              <div class="mb-0">
                <base-radio v-model="plan.planType" label="expenses">Expenses</base-radio>
                <base-radio v-model="plan.planType" label="income">Income</base-radio>
              </div>
            </div>
          </div>
        </div>
      <template slot="footer">
        <base-button v-if="plan.id" @click.native="editPlan()">Edit</base-button>
        <base-button v-if="!plan.id" @click.native="addPlan()">Add</base-button>
        <base-button
          type="danger"
          @click.native="modals.planModal = false"
          >Close
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import store from "@/store";
import swal from 'sweetalert2';
import randomColor from "randomcolor";
import BarChart from '@/components/Charts/BarChart';
import PieChart from '@/components/Charts/PieChart';
import LineChart from '@/components/Charts/LineChart';
import { BaseRadio } from "@/components";
import Modal from '@/components/Modal';
import TaskList from './Dashboard/TaskList';
import * as chartConfigs from '@/components/Charts/config';
import config from '@/config';
import { mapGetters } from "vuex";
import { ADD_PLAN, FETCH_PLAN, DELETE_PLAN, EDIT_PLAN, FETCH_INCOME, FETCH_EXPENSES, EDIT_STARTMONTH } from "@/store/actions.type";
import { ADD_MONTH, SUB_MONTH } from "@/store/mutations.type";

export default {
  components: {
    Modal,
    LineChart,
    TaskList,
    BarChart,
    BaseRadio,
    PieChart
  },
computed: {
   ...mapGetters([
     "isLoading",
     "incomeTotal",
     "income",
     "expenses",
     "expensesTotal",
     "cal",
     "currentUser",
     "plan",
     "month",
     "year",
     "monthNames",
     "curr"
   ]),
   overviewChart(){
     return {
         extraOptions: chartConfigs.barChartOptions,
         chartData: {
           labels: ['Expenses', 'Income'],
           datasets: [{
             label:"Planned",
             fill: true,
             borderColor: config.colors.info,
             borderWidth: 1,
             borderDash: [],
             borderDashOffset: 0.0,
             data: [this.expensesTotal.planned, this.incomeTotal.planned],
           },
           {
             label:"Actual",
             fill: true,
             borderColor: config.colors.danger,
             borderWidth: 1,
             borderDash: [],
             borderDashOffset: 0.0,
             data: [this.expensesTotal.actual,this.incomeTotal.actual],
           }
         ]
         },
         gradientColors: config.colors.primaryGradient,
         gradientStops: [1, 0.4, 0],
     }
   },
   expansesChart(){
     var datasets = []
     var labels = []

     var plannedObj = {
         label:"Planned",
         fill: true,
         borderColor: config.colors.info,
         borderWidth: 1,
         borderDash: [],
         borderDashOffset: 0.0,
         data: [],
     }
     var actualObj = {
         label:"Actual",
         fill: true,
         borderColor: config.colors.danger,
         borderWidth: 1,
         borderDash: [],
         borderDashOffset: 0.0,
         data: [],
     }
    this.expenses.map(expense=>{
      plannedObj.data.push(expense.planned);
      actualObj.data.push(expense.actual);
      labels.push(expense.category);
     });
     return {
         extraOptions: chartConfigs.barChartOptions,
         chartData: {
           labels: labels,
           datasets: [plannedObj, actualObj]
         },
         gradientColors: config.colors.primaryGradient,
         gradientStops: [1, 0.4, 0],
     }
   },
   incomeChart(){
     var datasets = []
     var labels = []

     var plannedObj = {
         label:"Planned",
         fill: true,
         borderColor: config.colors.info,
         borderWidth: 1,
         borderDash: [],
         borderDashOffset: 0.0,
         data: [],
     }
     var actualObj = {
         label:"Actual",
         fill: true,
         borderColor: config.colors.danger,
         borderWidth: 1,
         borderDash: [],
         borderDashOffset: 0.0,
         data: [],
     }
    this.income.map(incom=>{
      plannedObj.data.push(incom.planned);
      actualObj.data.push(incom.actual);
      labels.push(incom.category);
     });
     return {
         extraOptions: chartConfigs.barChartOptions,
         chartData: {
           labels: labels,
           datasets: [plannedObj, actualObj]
         },
         gradientColors: config.colors.primaryGradient,
         gradientStops: [1, 0.4, 0],
     }
   },
   plannedExpensesPieChart(){
    var labels = []
    var datasets = []

    var plannedObj = {
      fill: true,
      borderWidth: 0,
      borderDash: [],
      borderDashOffset: 0.0,
      backgroundColor: [],
      pointBorderWidth: 20,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 15,
      pointRadius: 4,
      data: [],
    }

     this.expenses.map(expense=>{
       plannedObj.data.push(expense.planned);
       labels.push(expense.category);
      });
      plannedObj.backgroundColor= this.expensesPieChartColors;

     return {
       extraOptions: chartConfigs.pieChartOptions,
       chartData: {
         labels: labels,
         datasets: [plannedObj]
       }
     }
   },
   actualExpensesPieChart(){
    var labels = []
    var datasets = []

    var actualObj = {
      fill: true,
      borderWidth: 0,
      borderDash: [],
      borderDashOffset: 0.0,
      backgroundColor: [],
      pointBorderWidth: 20,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 15,
      pointRadius: 4,
      data: [],
    }

     this.expenses.map(expense=>{
       actualObj.data.push(expense.actual);
       labels.push(expense.category);
      });
      actualObj.backgroundColor= this.expensesPieChartColors;

     return {
       extraOptions: chartConfigs.pieChartOptions,
       chartData: {
         labels: labels,
         datasets: [actualObj]
       }
     }
   },
   plannedincomePieChart(){
    var labels = []
    var datasets = []

    var plannedObj = {
      fill: true,
      borderWidth: 0,
      borderDash: [],
      borderDashOffset: 0.0,
      backgroundColor: [],
      pointBorderWidth: 20,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 15,
      pointRadius: 4,
      data: [],
    }

     this.income.map(incom=>{
       plannedObj.data.push(incom.planned);
       labels.push(incom.category);
      });
      plannedObj.backgroundColor= this.incomePieChartColors;

     return {
       extraOptions: chartConfigs.pieChartOptions,
       chartData: {
         labels: labels,
         datasets: [plannedObj]
       }
     }
   },
   actualincomePieChart(){
    var labels = []
    var datasets = []

    var plannedObj = {
      fill: true,
      borderWidth: 0,
      borderDash: [],
      borderDashOffset: 0.0,
      backgroundColor: [],
      pointBorderWidth: 20,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 15,
      pointRadius: 4,
      data: [],
    }

     this.income.map(incom=>{
       plannedObj.data.push(incom.actual);
       labels.push(incom.category);
      });
      plannedObj.backgroundColor= this.incomePieChartColors;

     return {
       extraOptions: chartConfigs.pieChartOptions,
       chartData: {
         labels: labels,
         datasets: [plannedObj]
       }
     }
   },
 },
 mounted(){
   this.expensesPieChartColors = this.randomColor({luminosity: 'light', count:this.expenses.length});
   this.incomePieChartColors = this.randomColor({luminosity: 'light', count:this.income.length});
   this.initBigChart(0);
 },
 methods:{
   addPlan(){
     this.$store.dispatch(ADD_PLAN);
     this.modals.planModal = false;
   },
   editPlan(){
    this.$store.dispatch(EDIT_PLAN);
    this.modals.planModal = false;
   },
   addPlanModal(type){
     delete this.plan.id
     this.plan.planType = type;
     this.modals.planModal = true;
   },
   addStartModel(){
     this.startAmount = this.cal.startAmount;
     this.modals.startModel = true;
   },
   deletePlanCall(planId, type){
     this.$store.dispatch(DELETE_PLAN, {planId,type});
   },
   getPlan(planId){
     this.$store.dispatch(FETCH_PLAN, planId);
     this.modals.planModal = true;
   },
   addMonth(){
     this.$store.commit(ADD_MONTH);
   },
   subsMonth(){
     this.$store.commit(SUB_MONTH);
   },
   editStartAmount(){
     this.$store.dispatch(EDIT_STARTMONTH, this.startAmount);
     this.modals.startModel = false;
   },
   deletePlan(planId,type){
     const swalWithBootstrapButtons4 = swal.mixin({
       customClass: {
         confirmButton: "btn btn-success btn-fill",
         cancelButton: "btn btn-danger btn-fill",
       },
       buttonsStyling: false,
     });
     swalWithBootstrapButtons4
       .fire({
         title: "Are you sure?",
         text: `You won't be able to revert this!`,
         confirmButtonText: "Yes, delete it!",
         cancelButtonText: "Cancel",
         showCancelButton: true,
       })
       .then((result) => {
         if (result.value) {
           this.deletePlanCall(planId,type);
           const swalWithBootstrapButtons5 = swal.mixin({
             customClass: {
               confirmButton: "btn btn-success btn-fill",
             },
             buttonsStyling: false,
           });
           swalWithBootstrapButtons5.fire({
             title: "Deleted!",
             text: "Your file has been deleted.",
           });
         }
       });
   },
   initBigChart(index) {
     let chartData = {
       datasets: [{
         fill: true,
         borderColor: config.colors.primary,
         borderWidth: 2,
         borderDash: [],
         borderDashOffset: 0.0,
         pointBackgroundColor: config.colors.primary,
         pointBorderColor: 'rgba(255,255,255,0)',
         pointHoverBackgroundColor: config.colors.primary,
         pointBorderWidth: 20,
         pointHoverRadius: 4,
         pointHoverBorderWidth: 15,
         pointRadius: 4,
         data: this.bigLineChart.allData[index]
       }],
       labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
     }
     this.$refs.bigChart.updateGradients(chartData);
     this.bigLineChart.chartData = chartData;
     this.bigLineChart.activeIndex = index;
   },
 },
 watch: {
  month(){
    this.$store.dispatch(FETCH_INCOME)
    this.$store.dispatch(FETCH_EXPENSES)
  }
},
 data() {
   return {
    startAmount:0,
    modals: {
       planModal:false,
       startModel:false
     },
    randomColor:randomColor,
    expensesPieChartColors:[],
    incomePieChartColors:[],
    bigLineChart: {
      allData: [
        [100, 70, 90, 70, 85, 60, 75, 75, 90, 80, 110, 100],
        [80, 120, 105, 110, 95, 105, 90, 100, 80, 95, 70, 120],
        [60, 80, 65, 130, 80, 105, 90, 130, 70, 115, 60, 130]
      ],
      activeIndex: 0,
      chartData: {
        datasets: [{ }],
        labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      },
      extraOptions: chartConfigs.purpleChartOptions,
      gradientColors: config.colors.primaryGradient,
      gradientStops: [1, 0.4, 0],
      categories: []
    },
    chartCategories: [
      "Balances",
      "Spendings",
      "Daily Spendings"
    ],
   };
 },
}
</script>

<style lang="css" scoped>
*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;}
hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible;}
h3{margin-top:0;margin-bottom:.5rem;}
p{margin-top:0;margin-bottom:1rem;}
h3{margin-bottom:.5rem;font-family:inherit;font-weight:400;color:#32325d;}
h3{font-size:1.4375rem;}
hr{margin-top:2rem;margin-bottom:2rem;border:0;border-top:.0625rem solid rgba(34,42,66,.1);}
.row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px;}
.col-5,.col-7,.col-lg-3,.col-md-6{position:relative;width:100%;padding-right:15px;padding-left:15px;}
.col-5{-webkit-box-flex:0;}
.col-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%;}
.col-7{-webkit-box-flex:0;}
.col-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%;}
@media (min-width:768px){
.col-md-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
}
@media (min-width:992px){
.col-lg-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%;}
}
.card{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:.0625rem solid rgba(34,42,66,.05);border-radius:.2857rem;}
.card-body{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.5rem;}
.card-title{margin-bottom:1.25rem;}
.card-footer{padding:1.25rem 1.5rem;background-color:#f6f9fc;border-top:.0625rem solid rgba(34,42,66,.05);}
.card-footer:last-child{border-radius:0 0 .2232rem .2232rem;}
.text-center{text-align:center!important;}
@media print{
*,:after,:before{text-shadow:none!important;-webkit-box-shadow:none!important;box-shadow:none!important;}
h3,p{orphans:3;widows:3;}
h3{page-break-after:avoid;}
}
h3{line-height:1.2;}
.card h3,.card p,h3{color:hsla(0,0%,100%,.8);}
h3{font-weight:400;}
h3{margin-bottom:30px;}
h3{line-height:1.4em;}
p{color:hsla(0,0%,100%,.8);margin-bottom:5px;}
.card-category{text-transform:capitalize;font-weight:400;color:hsla(0,0%,100%,.6);font-size:.75rem;}
.card-category{font-size:.75rem;}
hr{border-top:1px solid rgba(0,0,0,.1);margin-top:1rem;margin-bottom:1rem;}
.white-content h3,.white-content p{color:#1d253b;}
.white-content .card:not(.card-white){background:#fff;-webkit-box-shadow:0 1px 15px 0 hsla(0,0%,48.2%,.05);box-shadow:0 1px 15px 0 hsla(0,0%,48.2%,.05);}
.white-content .card:not(.card-white) .card-body .card-category,.white-content .card:not(.card-white) .card-body .card-title{color:#1d253b;}
.white-content .card:not(.card-pricing).card-stats hr{border-color:rgba(29,37,59,.1);}
.white-content .card:not(.card-pricing).card-stats .card-title{color:#1d253b;}
.white-content .card:not(.card-pricing).card-stats .card-category,.white-content .card:not(.card-pricing).card-stats .stats{color:grey;}
.card{background:#27293d;border:0;position:relative;width:100%;margin-bottom:30px;-webkit-box-shadow:0 1px 20px 0 rgba(0,0,0,.1);box-shadow:0 1px 20px 0 rgba(0,0,0,.1);}
.card .card-title{margin-bottom:.75rem;}
.card .card-body{padding:15px;}
.card .card-body .card-title{color:#fff;text-transform:inherit;font-weight:300;margin-bottom:.75rem;}
.card .card-body .card-category{color:hsla(0,0%,100%,.6);}
.card .card-footer{background-color:transparent;border:0;padding:15px;}
.card .card-footer .stats i{margin-right:5px;position:relative;}
.card-body{padding:1.25rem;}
.card-stats hr{margin:5px 15px;}
.card-stats .info-icon{height:50px;width:50px;border-radius:50%;background:#e14eca;background-image:-webkit-gradient(linear,right top,left bottom,from(#e14eca),color-stop(#ba54f5),to(#e14eca));background-image:linear-gradient(to bottom left,#e14eca,#ba54f5,#e14eca);background-size:210% 210%;background-position:100% 0;}
.card-stats .info-icon i{color:#fff;font-size:1.7em;padding:14px 13px;}
.card-stats .info-icon.icon-danger{background:#fd5d93;background-image:-webkit-gradient(linear,right top,left bottom,from(#fd5d93),color-stop(#ec250d),to(#fd5d93));background-image:linear-gradient(to bottom left,#fd5d93,#ec250d,#fd5d93);background-size:210% 210%;background-position:100% 0;}
.card-stats .numbers{text-align:right;}
.card-stats .numbers .card-title{margin-top:0;}
.card-stats .numbers .card-category{margin-bottom:0;color:#9a9a9a;}
.card-stats .card-footer{padding:0;}
.card-stats hr{border-color:#2b3553;}
.card-stats .stats{color:hsla(0,0%,100%,.6);margin:10px 15px;font-size:.9em;}
.tim-icons{display:inline-block;font:normal normal normal 1em/1 Nucleo;vertical-align:middle;speak:none;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.icon-molecule-40:before{content:"\ea38";}
.icon-watch-time:before{content:"\ea5e";}

*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;}
label{display:inline-block;margin-bottom:.5rem;}
input{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
input{overflow:visible;}
input[type=checkbox]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0;}
.row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px;}
.col-md-3,.col-md-9{position:relative;width:100%;padding-right:15px;padding-left:15px;}
@media (min-width:768px){
.col-md-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%;}
.col-md-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%;}
}
.form-control{display:block;width:100%;height:calc(2.25rem + 2px);padding:.5rem .7rem;font-size:.875rem;font-weight:400;line-height:1.42857;color:hsla(0,0%,100%,.8);background-color:transparent;background-clip:padding-box;border:1px solid #cad1d7;border-radius:.25rem;-webkit-box-shadow:none;box-shadow:none;-webkit-transition:all .2s cubic-bezier(.68,-.55,.265,1.55);transition:all .2s cubic-bezier(.68,-.55,.265,1.55);}
@media (prefers-reduced-motion:reduce){
.form-control{-webkit-transition:none;transition:none;}
}
.form-control::-ms-expand{background-color:transparent;border:0;}
.form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 hsla(0,0%,100%,.8);}
.form-control:focus{color:hsla(0,0%,100%,.8);background-color:#fff;border-color:rgba(50,151,211,.25);outline:0;}
.form-control::-webkit-input-placeholder{color:#adb5bd;}
.form-control::-moz-placeholder{color:#adb5bd;}
.form-control:-ms-input-placeholder{color:#adb5bd;}
.form-control::-ms-input-placeholder{color:#adb5bd;opacity:1;}
.form-control::placeholder{color:#adb5bd;opacity:1;}
.form-control:disabled{background-color:#e9ecef;opacity:1;}
.col-form-label{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.42857;}
.form-group{margin-bottom:1rem;}
.form-check{position:relative;display:block;padding-left:1.25rem;}
.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem;}
.form-check-label{margin-bottom:0;}
.mb-0{margin-bottom:0!important;}
@media print{
*,:after,:before{text-shadow:none!important;-webkit-box-shadow:none!important;box-shadow:none!important;}
}
.form-control:-moz-placeholder,.form-control::-moz-placeholder{color:#6c757c;opacity:1;filter:alpha(opacity=100);}
.form-control::-webkit-input-placeholder{color:#6c757c;opacity:1;filter:alpha(opacity=100);}
.form-control:-ms-input-placeholder{color:#6c757c;opacity:1;filter:alpha(opacity=100);}
.form-control{border-color:#2b3553;border-radius:.4285rem;font-size:.75rem;-webkit-transition:color .3s ease-in-out,border-color .3s ease-in-out,background-color .3s ease-in-out;transition:color .3s ease-in-out,border-color .3s ease-in-out,background-color .3s ease-in-out;}
.form-control:focus{border-color:#e14eca;background-color:transparent;-webkit-box-shadow:none;box-shadow:none;}
@media (max-width:575.98px){
.form-horizontal .col-form-label{text-align:inherit;padding-top:0;}
}
.form-group .form-control{padding:10px 18px;}
.form-group{margin-bottom:10px;position:relative;}
.form-horizontal .col-form-label{padding:10px 5px 0 15px;text-align:right;max-width:180px;}
input{font-family:Poppins,sans-serif;}
.form-check{margin-top:.5rem;padding-left:0;}
.form-check .form-check-label{display:inline-block;position:relative;cursor:pointer;padding-left:25px;line-height:18px;margin-bottom:0;-webkit-transition:color .3s linear;transition:color .3s linear;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
.form-check .form-check-sign:after,.form-check .form-check-sign:before{content:" ";display:inline-block;position:absolute;width:17px;height:17px;left:0;cursor:pointer;border-radius:3px;top:0;border:1px solid #818181;-webkit-transition:opacity .3s linear;transition:opacity .3s linear;}
.form-check input[type=checkbox]:checked+.form-check-sign:before{border:none;background-color:#e14eca;}
.form-check .form-check-sign:after{font-family:nucleo;content:"\ea1b";top:0;text-align:center;font-size:14px;opacity:0;color:#fff;font-weight:600;border:0;background-color:inherit;}
.form-check input[type=checkbox]{opacity:0;position:absolute;visibility:hidden;}
.form-check input[type=checkbox]:checked+.form-check-sign:after{opacity:1;font-size:10px;margin-top:0;}
.form-check input[type=checkbox]+.form-check-sign:after{opacity:0;font-size:10px;margin-top:0;}
.form-check input[type=checkbox]:disabled+.form-check-sign{pointer-events:none;}
.card label{color:hsla(0,0%,100%,.6);}
.card label{font-size:.75rem;margin-bottom:5px;}
</style>
